import { render, staticRenderFns } from "./DashboardPerfomanceTileItem.vue?vue&type=template&id=4f01a5f3&lang=pug"
import script from "./DashboardPerfomanceTileItem.vue?vue&type=script&lang=ts"
export * from "./DashboardPerfomanceTileItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
